import * as React from 'react'
import { XhprofStatsData } from '../../../xhprof/XhprofProfiler'
import { DescendantPanel } from './descendantPanel'
import { XhprofReport } from '../../../xhprof/XhprofReportGenerator'

interface Props {
    panelsConfig: DescendantConfiguration[]
    toggledPanels: ToggledPanels
    selectedCall: string
    stats: XhprofStatsData
    xhprofReport: XhprofReport | null
    descendantPanelMaximized: boolean
    showPlusWhenPositive: boolean
    onTogglePanel: (type: Panel) => void
    onToggleMaximizePanel: (type: Panel) => void
    onSelectFunction: (call: string) => void
}

interface State {
    isOpen: boolean
}

interface ToggledPanels {
    parents: boolean
    children: boolean
    slowestPath: boolean
}

export interface DescendantConfiguration {
    active: (toggleState: ToggledPanels) => boolean
    key: Panel
    label: string
    data: (stats: XhprofStatsData, xhprofReport: XhprofReport | null, call: string) => any
}

export type Panel = 'parents' | 'children' | 'slowestPath'

export class DescendantPanelGroup extends React.PureComponent<Props, State> {
    public render() {
        const {
            panelsConfig,
            toggledPanels,
            descendantPanelMaximized,
            selectedCall,
            stats,
            xhprofReport,
            showPlusWhenPositive,
            onTogglePanel,
            onToggleMaximizePanel,
            onSelectFunction,
        } = this.props

        return (
            <div>
                {panelsConfig.map(panel => {
                    const { active, key, label, data } = panel
                    const showContent = active(toggledPanels) && !!stats && !!selectedCall
                    const panelData = stats && selectedCall ? data(stats, xhprofReport, selectedCall) : null
                    const callAmount = panelData ? Object.keys(panelData).length.toString() : '-'

                    const maximize = {
                        isActive: descendantPanelMaximized && active(toggledPanels),
                        handler: () => onToggleMaximizePanel(key),
                    }

                    const toggle = {
                        isActive: !descendantPanelMaximized && active(toggledPanels),
                        handler: () => onTogglePanel(key),
                    }

                    return (
                        <DescendantPanel
                            key={`panel_${panel.key}`}
                            label={label}
                            showContent={showContent}
                            panelData={panelData}
                            callAmount={callAmount}
                            maximizePanel={maximize}
                            togglePanel={toggle}
                            showPlusWhenPositive={showPlusWhenPositive}
                            onSelectFunction={onSelectFunction}
                        />
                    )
                })}
            </div>
        )
    }
}
